import { render, staticRenderFns } from "./ProjectTeammate.vue?vue&type=template&id=1285987a&"
import script from "./ProjectTeammate.vue?vue&type=script&lang=js&"
export * from "./ProjectTeammate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports